
export default {
    props: {
        stagePayConfig: {
            type: Object,
            required: true
        }
    },
    methods: {
        jumpPage () {
            const hasProtocol = this.stagePayConfig.jumpUrl.includes('http://') || this.stagePayConfig.jumpUrl.includes('https://')
            if (!hasProtocol)
            { window.open(`http://${this.stagePayConfig.jumpUrl}`) }
            else
            { window.open(this.stagePayConfig.jumpUrl) }
        }
    }
}
